'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_localization_package$() {
  this.aVY = null;
  this.aW1 = false;
  this.aVZ = null;
  this.aW0 = false;
  this.aW2 = null;
  this.aW3 = false;
}
export { $c_Lapp_localization_package$ as $c_Lapp_localization_package$ };
$p = $c_Lapp_localization_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_localization_package$;
/** @constructor */
function $h_Lapp_localization_package$() {
}
export { $h_Lapp_localization_package$ as $h_Lapp_localization_package$ };
$h_Lapp_localization_package$.prototype = $p;
$p.ay = (function() {
  if ((!this.aW1)) {
    this.aVY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$LocalizedText$(this);
    this.aW1 = true;
  }
  return this.aVY;
});
$p.cN = (function() {
  if ((!this.aW0)) {
    this.aVZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$LocalizedTextOf$(this);
    this.aW0 = true;
  }
  return this.aVZ;
});
$p.afa = (function() {
  if ((!this.aW3)) {
    this.aW2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Currency";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $m_Lapp_localization_package$().cN());
    this.aW3 = true;
  }
  return this.aW2;
});
var $d_Lapp_localization_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_localization_package$, "app.localization.package$", ({
  H1: 1,
  Xr: 1
}));
export { $d_Lapp_localization_package$ as $d_Lapp_localization_package$ };
var $n_Lapp_localization_package$;
function $m_Lapp_localization_package$() {
  if ((!$n_Lapp_localization_package$)) {
    $n_Lapp_localization_package$ = new $c_Lapp_localization_package$();
  }
  return $n_Lapp_localization_package$;
}
export { $m_Lapp_localization_package$ as $m_Lapp_localization_package$ };
//# sourceMappingURL=app.localization.package$.js.map
